import { Routes, Route, Navigate } from "react-router-dom";

import Home from "./pages/00-home.jsx";
import Login from "./pages/01-login.jsx";
import Dashboard from "./pages/02-dashboard.jsx";
import OperationDetails from "./pages/03-operation.jsx";

import AnalyticsPatient from "./pages/04-analytics-patient.jsx";
import AnalyticsAllPatients from "./pages/05-analytics-all-patients.jsx";
import AnalyticsHospital from "./pages/06-analytics-hospital.jsx";

import AdminUser from "./pages/07-admin-user.jsx";
import AdminAuth from "./pages/08-admin-authentication.jsx";
import AdminPatientOps from "./pages/09-admin-patientoperations.jsx"

import Help from "./pages/10-help-page.jsx"
import Settings from "./pages/11-settings.jsx"
import Terms from "./pages/12-terms-of-use-and-about.jsx"

import Layout from "./components/Layout.jsx"; 

import ProtectedRoute from "./components/protected/ProtectedRoute.jsx";

import './styles/colours.css';

function App() {
  return (

    <Routes>

      {/* When pnpm start it goes to login */}
      <Route path="/" element={<Navigate to="/login" replace />} />

      {/* Login route without sidebar */}
      <Route path="/login" element={<Login />} />

      <Route path="/" element={<Layout />}>
        <Route path="/home" element={<Home />} />
        <Route path="/dashboard" element={
          <ProtectedRoute permissions={(1 << 4)}> {/* ReadOperations */}
            <Dashboard />
          </ProtectedRoute>
          } />
        <Route path="/admin/user" element={
          <ProtectedRoute permissions={(1 << 16) + (1 << 17)}> {/* ReadSystemStatus, ReadAuditLogs */}
            <AdminUser />
          </ProtectedRoute>
          } />

          {/** Piotr change the permissions if it's not right. Probably isn't. Thanks. For the two new added. 
           */}
        <Route path="/admin/authentication" element={
          <ProtectedRoute permissions={(1 << 16) + (1 << 17)}> {/* ReadSystemStatus, ReadAuditLogs */}
            <AdminAuth />
          </ProtectedRoute>
          } />

        <Route path="/admin/patient-operations" element={
          <ProtectedRoute permissions={(1 << 16) + (1 << 17)}> {/* ReadSystemStatus, ReadAuditLogs */}
            <AdminPatientOps />
          </ProtectedRoute>
          } />

        <Route path="/operation/:operationId" element={
          <ProtectedRoute permissions={(1 << 0) + (1 << 4)}> {/* ReadPatients, ReadOperations */}
            <OperationDetails />
          </ProtectedRoute>
          } />
        
        <Route path="/analytics/patient" element={<AnalyticsPatient />} />
        <Route path="/analytics/all-patients" element={<AnalyticsAllPatients />} />
        <Route path="/analytics/hospital" element={<AnalyticsHospital />} />

        <Route path="/help" element={<Help />} /> 
        <Route path="/settings" element={<Settings />} /> 

        <Route path="/terms" element={<Terms />} /> 

        </Route>
    </Routes>



  );
}

export default App;
